function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 15,
  cy: 15,
  fill: "currentColor",
  fillRule: "nonzero",
  r: 14.5,
  stroke: "#071920"
}), React.createElement("g", {
  transform: "translate(5 5)"
}, React.createElement("g", {
  stroke: "#071920",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  className: "icon",
  d: "m16 14.87c-.1210014.481113-.3239686.9377892-.6 1.35-.3916619.555523-.895941 1.022322-1.48 1.37"
}), React.createElement("path", {
  className: "icon",
  d: "m4.57 9.6v3.29c.01161095.4251854-.31549888.783238-.74.81-.92 0-1.69-1.25-1.69-2.73-.06440176-.5538731.09627975-1.11041167.44598663-1.54472505.34970687-.43431338.85915221-.71002913 1.41401337-.76527495v-1.11c0-3.3137085 2.6862915-6 6-6s6 2.6862915 6 6v1.11c.5607495.05483039 1.0752671.33479825 1.4258542.77585948s.5072481 1.00547922.4341458 1.56414052c0 1.48-.77 2.73-1.69 2.73-.4245011-.026762-.7516109-.3848146-.74-.81v-3.32"
}))));

var SvgController = function SvgController(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: 30,
    height: 30,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgController, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/controller.a8908c6f.svg";
export { ForwardRef as ReactComponent };